import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { Col, Card, Button } from 'reactstrap';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import ModalMessage from '../../../../../shared/components/Modal';
import moment from 'moment';

const renderField = ({
    input, placeholder, type, meta: { touched, error },
}) => (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
        <input {...input} placeholder={placeholder} type={type} />
        {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
);

renderField.propTypes = {
    input: PropTypes.shape().isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }),
};

renderField.defaultProps = {
    placeholder: '',
    meta: null,
    type: 'text',
};


class ProtocolDeviations extends Component {
    constructor(props) {
        super(props);
        this.state = {
            protocolDeviation: "",
            dateDeviation: new Date(),
            clasification: "",
            whoSawDeviation: "",
            deviationAfectation: "",
            deviationCause: "",
            description: "",
            deviationType: "",
            preventActions: "",
            corrcteActions: "",
            whatWay: "",
            openAlert: false,
            modalAlert: { message: '', color: '', title: '' },
            errors: {}

        }
    }

    handlerProtocolDeviation = (protocolDeviation) => {
        this.setState({ protocolDeviation: protocolDeviation });
    }

    handlerDateDeviation = (dateDeviation) => {
        this.setState({ dateDeviation: dateDeviation });
    }

    handlerClasification = (clasification) => {
        this.setState({ clasification: clasification });
    }

    handlerWhoSawDeviation = (whoSawDeviation) => {
        this.setState({ whoSawDeviation: whoSawDeviation });
    }

    handlerDeviationAfectation = (deviationAfectation) => {
        this.setState({ deviationAfectation: deviationAfectation });
    }

    handlerDeviationCause = (deviationCause) => {
        this.setState({ deviationCause: deviationCause });
    }

    handlerDescription = (description) => {
        this.setState({ description: description });
    }

    handlerDeviationType = (deviationType) => {
        this.setState({ deviationType: deviationType });
    }

    handlerPreventActions = (preventActions) => {
        this.setState({ preventActions: preventActions });
    }

    handlerCorrcteActions = (corrcteActions) => {
        this.setState({ corrcteActions: corrcteActions });
    }

    handlerWhatWay = (whatWay) => {
        this.setState({ whatWay: whatWay })
    }

    validate = () => {
        let errors = {};
        let error = false;

        if (this.state.clasification === "") {
            error = true;
            errors.clasification = "Ingresa una clasificacion";
        } else {
            errors.clasification = "";
        }

        if (this.state.whoSawDeviation === "") {
            error = true;
            errors.whoSawDeviation = "Ingresa quien detecto la desviacion";
        } else {
            errors.whoSawDeviation = "";
        }

        if (this.state.deviationAfectation === "") {
            error = true;
            errors.deviationAfectation = "Ingresa la si afecta la desviacion";
        } else {
            errors.deviationAfectation = "";
        }

        if (this.state.deviationCause === "") {
            error = true;
            errors.deviationCause = "Ingresa la causa de la desviacion";
        } else {
            errors.deviationCause = "";
        }

        if (this.state.description === "") {
            error = true;
            errors.description = "Ingresa una descripcion";
        } else {
            errors.description = "";
        }

        if (this.state.deviationType === "") {
            error = true;
            errors.deviationType = "Ingresa el tipo de desviacion";
        } else {
            errors.deviationType = "";
        }

        if (this.state.preventActions === "") {
            error = true;
            errors.preventActions = "Ingresa las acciones preventivas";
        } else {
            errors.preventActions = "";
        }

        if (this.state.corrcteActions === "") {
            error = true;
            errors.corrcteActions = "Ingresa la acciones correctivas";
        } else {
            errors.corrcteActions = "";
        }

        this.setState({ errors: errors });
        return error;

    }

    sendData = () => {

        if (!this.validate()) {

            const dataSend = {
                id_historia: this.props.id_historia,
                desviacion_protocolo: this.state.protocolDeviation,
                fecha_desviacion: moment(this.state.dateDeviation).format("YYYY/MM/DD"),
                clasificacion: this.state.clasification,
                quien_detecto_desviacion: this.state.whoSawDeviation,
                desviacion_afecta_sujeto: this.state.deviationAfectation,
                como_afecta: this.state.whatWay,
                desviacion_causa: this.state.deviationCause,
                descripcion: this.state.description,
                desviacion_tipo: this.state.deviationType,
                acciones_preventivas: this.state.preventActions,
                acciones_correctivas: this.state.corrcteActions
            };

            console.log(dataSend);

            fetch(process.env.REACT_APP_PUBLIC_URL + 'desviacion-protocolo/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    this.setState({
                        openAlert: true,
                        modalAlert: {
                            message: 'Desviación Registrada Correctamente',
                            color: 'success',
                            title: "Exitoso!"
                        }
                    });

                }).catch((e) => {
                    console.log(e);
                });
        } else {
            this.setState({
                openAlert: true,
                modalAlert: {
                    message: 'Ingresa los datos Correctamente',
                    color: 'danger',
                    title: "Error!"
                }
            });
        }
    }


    render() {

        return (
            <Col>
                <Card body outline color="secondary">
                    <div className="form" style={{ display: "flex", flexDirection: "column" }}>
                        <div className="card__title">
                            <h5 className="bold-text">Desviaciones al Protocolo</h5>
                        </div>
                        <div style={{ width: '80%' }}>
                            <div style={{ width: 350 }}>
                                <span className="form__form-group-label">Desviaciones al Protocolo</span>
                                <div className="form__form-group-field">
                                    <label
                                        className="radio-btn"
                                    >
                                        <input
                                            className="radio-btn__radio"
                                            name="event-adverse"
                                            type="radio"
                                            value={'Si'}
                                            onChange={(e) => {
                                                this.handlerProtocolDeviation(e.target.value);

                                            }}
                                        />
                                        <span className="radio-btn__radio-custom" />
                                        <span className="radio-btn__label">{"Sí"}</span>
                                    </label>
                                    <label
                                        className="radio-btn"
                                    >
                                        <input
                                            className="radio-btn__radio"
                                            name="event-adverse"
                                            type="radio"
                                            value={'No'}
                                            onChange={(e) => {
                                                this.handlerProtocolDeviation(e.target.value);
                                            }}
                                        />
                                        <span className="radio-btn__radio-custom" />
                                        <span className="radio-btn__label">{"No"}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        {this.state.protocolDeviation === 'Si' ?
                            <Fragment>
                                <div style={{ display: 'flex', marginTop: 50, }}>

                                    <div style={{ marginRight: 20, }} >
                                        <span className="form__form-group-label">Fecha de la Desviación </span>
                                    </div>
                                    <MuiPickersUtilsProvider utils={MomentUtils} >
                                        <DatePicker
                                            views={["year", "month", "date"]}
                                            className="material-form__field"
                                            value={this.state.dateDeviation}
                                            style={{ width: 200, marginLeft: 20 }}
                                            onChange={(date) => {
                                                //this.handlerBirthDate(new Date(date));
                                                this.handlerDateDeviation(date);
                                            }}
                                            animateYearScrolling
                                            format="yyyy/MM/D"
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>

                                <div style={{ display: 'flex', marginTop: 50, }}>

                                    <div style={{ marginRight: 20, width: '15%' }} >
                                        <span className="form__form-group-label">Clasificación de la Desviación </span>
                                    </div>
                                    <div className="form__form-group-field" style={{ marginLeft: 20 }}>
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="clasificacion"
                                                type="radio"
                                                value={'Desviación al protocolo'}
                                                onChange={(e) => {
                                                    //console.log(e.target);
                                                    this.handlerClasification(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"Desviación al protocolo"}</span>
                                        </label>
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="clasificacion"
                                                type="radio"
                                                value={'Desviación a las Buenas Prácticas Clínicas'}
                                                onChange={(e) => {
                                                    this.handlerClasification(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"Desviación a las Buenas Prácticas Clínicas"}</span>
                                        </label>
                                        <span className="form__form-group-label" style={{ color: "red" }}>
                                            {this.state.errors.hasOwnProperty("clasification") ? this.state.errors.clasification : ""}
                                        </span>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', marginTop: 50, }}>

                                    <div style={{ marginRight: 20, width: '15%' }} >
                                        <span className="form__form-group-label">Quién detecto la Desviación </span>
                                    </div>
                                    <div className="form__form-group-field" style={{ marginLeft: 20 }}>
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="quien-detecto"
                                                type="radio"
                                                value={'Investigador o su Delegado'}
                                                onChange={(e) => {
                                                    //console.log(e.target);
                                                    this.handlerWhoSawDeviation(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"Investigador o su Delegado"}</span>
                                        </label>
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="quien-detecto"
                                                type="radio"
                                                value={'Patrocinador o su representante'}
                                                onChange={(e) => {
                                                    this.handlerWhoSawDeviation(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"Patrocinador o su representante"}</span>
                                        </label>
                                        <span className="form__form-group-label" style={{ color: "red" }}>
                                            {this.state.errors.hasOwnProperty("whoSawDeviation") ? this.state.errors.whoSawDeviation : ""}
                                        </span>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', marginTop: 50, }}>

                                    <div style={{ marginRight: 20, width: '25%' }} >
                                        <span className="form__form-group-label" > ¿La desviacion afecta al sujeto?</span>
                                    </div>
                                    <div className="form__form-group-field">
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="afetation"
                                                type="radio"
                                                value={'Si'}
                                                onChange={(e) => {
                                                    //console.log(e.target);
                                                    this.handlerDeviationAfectation(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"Sí"}</span>
                                        </label>
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="afetation"
                                                type="radio"
                                                value={'No'}
                                                onChange={(e) => {
                                                    this.handlerDeviationAfectation(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"No"}</span>
                                        </label>
                                        <div className="form__form-group" >
                                            <span className="form__form-group-label" style={{ marginLeft: 20 }}> ¿De que manera?</span>
                                            <div className="form__form-group-field" >
                                                <input
                                                    name="product-text"
                                                    component={renderField}
                                                    type="text"
                                                    disabled={this.state.deviationAfectation !== "Si"}
                                                    style={{ width: '60%', marginTop: 10 }}
                                                    onChange={(e) => {
                                                        this.handlerWhatWay(e.target.value);
                                                    }}
                                                />
                                                <span className="form__form-group-label" style={{ color: "red" }}>
                                                    {this.state.errors.hasOwnProperty("deviationAfectation") ? this.state.errors.deviationAfectation : ""}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div style={{ display: 'flex', marginTop: 50, }}>

                                    <div style={{ marginRight: 20, width: '15%' }} >
                                        <span className="form__form-group-label">La desviacion es causada por  </span>
                                    </div>
                                    <div className="form__form-group-field" style={{ marginLeft: 20 }}>
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="caused-by"
                                                type="radio"
                                                value={'El equipo investigador'}
                                                onChange={(e) => {
                                                    //console.log(e.target);
                                                    this.handlerDeviationCause(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"El equipo investigador"}</span>
                                        </label>
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="caused-by"
                                                type="radio"
                                                value={'El paciente'}
                                                onChange={(e) => {
                                                    this.handlerDeviationCause(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"El paciente"}</span>
                                        </label>
                                        <span className="form__form-group-label" style={{ color: "red" }}>
                                            {this.state.errors.hasOwnProperty("deviationCause") ? this.state.errors.deviationCause : ""}
                                        </span>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', marginTop: 40, }}>
                                    <div style={{ marginRight: 20 }} >
                                        <span className="form__form-group-label">Descripción</span>
                                    </div>
                                    <div className="form__form-group-field">
                                        <Field
                                            name="textarea-description"
                                            component="textarea"
                                            type="text"
                                            style={{ width: '90%' }}
                                            //value={this.props.PhysicalExam.skin_appendages}
                                            onChange={(e) => {
                                                this.handlerDescription(e.target.value);
                                            }}
                                        />
                                        <span className="form__form-group-label" style={{ color: "red" }}>
                                            {this.state.errors.hasOwnProperty("description") ? this.state.errors.description : ""}
                                        </span>
                                    </div>
                                </div>


                                <div style={{ display: 'flex', marginTop: 50, }}>

                                    <div style={{ marginRight: 20, width: '13%' }} >
                                        <span className="form__form-group-label">Tipo de Desviación </span>
                                    </div>
                                    <div className="form__form-group-field" style={{ marginLeft: 20, }}>
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="type"
                                                type="radio"
                                                value={'leves'}
                                                onChange={(e) => {
                                                    //console.log(e.target);
                                                    this.handlerDeviationType(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"Leves"}</span>
                                        </label>
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="type"
                                                type="radio"
                                                value={'Mayores o Graves'}
                                                onChange={(e) => {
                                                    this.handlerDeviationType(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"Mayores o Graves"}</span>
                                        </label>
                                        <label
                                            className="radio-btn"
                                        >
                                            <input
                                                className="radio-btn__radio"
                                                name="type"
                                                type="radio"
                                                value={'Criticas o muy graves'}
                                                onChange={(e) => {
                                                    this.handlerDeviationType(e.target.value);
                                                }}
                                            />
                                            <span className="radio-btn__radio-custom" />
                                            <span className="radio-btn__label">{"Criticas o muy graves"}</span>
                                        </label>
                                        <span className="form__form-group-label" style={{ color: "red" }}>
                                            {this.state.errors.hasOwnProperty("deviationType") ? this.state.errors.deviationType : ""}
                                        </span>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', marginTop: 40, }}>
                                    <div style={{ marginRight: 20 }} >
                                        <span className="form__form-group-label">Acciones Preventivas</span>
                                    </div>
                                    <div className="form__form-group-field">
                                        <Field
                                            name="textarea-prevent"
                                            component="textarea"
                                            type="text"
                                            style={{ width: '90%' }}
                                            //value={this.props.PhysicalExam.skin_appendages}
                                            onChange={(e) => {
                                                this.handlerPreventActions(e.target.value);
                                            }}
                                        />
                                        <span className="form__form-group-label" style={{ color: "red" }}>
                                            {this.state.errors.hasOwnProperty("preventActions") ? this.state.errors.preventActions : ""}
                                        </span>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', marginTop: 40, }}>
                                    <div style={{ marginRight: 20 }} >
                                        <span className="form__form-group-label">Acciones Correctivas</span>
                                    </div>
                                    <div className="form__form-group-field">
                                        <Field
                                            name="textarea-correct"
                                            component="textarea"
                                            type="text"
                                            style={{ width: '90%' }}
                                            value={this.state.corrcteActions}
                                            onChange={(e) => {
                                                this.handlerCorrcteActions(e.target.value);
                                            }}
                                        />
                                        <span className="form__form-group-label" style={{ color: "red" }}>
                                            {this.state.errors.hasOwnProperty("corrcteActions") ? this.state.errors.corrcteActions : ""}
                                        </span>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', marginTop: 40, }}>

                                    <Button style={{ marginLeft: 60, marginTop: 20 }} size="sm" color="primary"
                                        onClick={() => {
                                            this.sendData();
                                        }}
                                    >Guardar</Button>
                                </div>
                                {this.state.openAlert ?
                                    <ModalMessage
                                        color={this.state.modalAlert.color}
                                        title={this.state.modalAlert.title}
                                        message={this.state.modalAlert.message}
                                        modal={this.state.openAlert}
                                        toggle={() => { this.setState({ openAlert: !this.state.openAlert }) }}
                                        onOk={() => { this.setState({ openAlert: !this.state.openAlert }) }}
                                    /> : null}
                            </Fragment>
                            : null}
                    </div>
                </Card>
            </Col>
        );
    }

}

export default reduxForm({
    form: `protocol-deviations-form`, // a unique identifier for this form
})(withTranslation('common')(ProtocolDeviations));
